import axios from "axios";
import { Notify } from "vant";
import getSignedObject from "@/service/sign";
import { getFromStorage } from "@/service/utils";
import store from "@/store/index";

const isDev = process.env.NODE_ENV === "development";

const service = axios.create({
  baseURL: isDev ? "" : process.env.VUE_APP_BASE_URL
  // timeout: 15000
});

service.interceptors.request.use(
  config => {
    config.headers["X-PRODUCT"] = process.env.VUE_APP_KEY;
    const user = getFromStorage("user") || {};
    if (user.session_token) {
      config.headers["X-SESSION-TOKEN"] = user.session_token;
    }
    if (config.method.toLocaleLowerCase() === "post") {
      config.data = getSignedObject(config.data || {});
    }
    return config;
  },
  error => {
    console.log(error);
    Promise.reject(error);
  }
);

const allowedCodes = [
  102 // No enough coins
];

service.interceptors.response.use(
  response => {
    const res = response.data || {};
    const resCode = response.status;
    if (resCode !== 200) {
      Notify(res.message);
      return Promise.reject("error");
    } else {
      // get book content, the response is directly set to res
      if (res instanceof Blob) {
        return res;
      } else if (res.code === 0) {
        return res.data;
      } else if (res.code === 10) {
        store.commit("SET_USER", {});
        return Promise.reject("auth failed");
      } else if (allowedCodes.indexOf(res.code) > -1) {
        // send whole response to next handler
        return res;
      } else {
        Notify(res.msg);
        return Promise.reject("error");
      }
    }
  },
  error => {
    console.log("err =>" + error);
    Notify(error.message);
    return Promise.reject(error);
  }
);

export default service;
